module.exports = __webpack_public_path__ + "img/route_9-3.270fce12.svg";